import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.889 8.111V5m6.222 3.111V5m-7 5.833H8.5m-.389 2.723H8.5m3.5-2.723h.389m3.5 0h.389M12 13.556h.389m3.5 0h.389m-.39 2.333h.39m-4.278 0h.389m-4.278 0H8.5M6.556 19h10.888c.86 0 1.556-.696 1.556-1.556V8.111c0-.859-.696-1.555-1.556-1.555H6.556C5.696 6.556 5 7.252 5 8.11v9.333C5 18.304 5.696 19 6.556 19Z",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };